import React from "react";
import Login from "../../../components/login";


export default function index() {


  return (
    <div>
      <Login/>
    </div>
  );
}
